/**
 * FormSubmitButton.js
 *
 * A reusable submit button component for forms that includes:
 * - Loading state indicator
 * - Disabled state handling
 * - Consistent styling
 * - Full-width responsive design
 */

import React from "react";
import { Button, CircularProgress } from "@mui/material";

/**
 * FormSubmitButton Component
 *
 * A submit button that shows a loading spinner when the form is being submitted
 * and can be disabled based on form state.
 *
 * @param {Object} props - Component properties
 * @param {string} props.label - Button text (defaults to "Submit")
 * @param {boolean} props.loading - Whether the form is submitting
 * @param {boolean} props.disabled - Whether the button should be disabled
 */
const FormSubmitButton = ({
  label = "Submit",
  loading = false,
  disabled = false,
}) => (
  <Button
    type="submit"
    fullWidth
    variant="contained"
    disabled={disabled || loading}
    sx={{ mt: 3, mb: 2 }}
  >
    {loading ? <CircularProgress size={24} color="inherit" /> : label}
  </Button>
);

export default FormSubmitButton;
